import { Component } from "react";

class ChunkErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  handleReload = () => {
    // Clear all chunk reload flags so lazyRetry gets a fresh attempt
    Object.keys(sessionStorage).forEach((key) => {
      if (key.startsWith("chunk_reload_") || key === "chunk_retry") {
        sessionStorage.removeItem(key);
      }
    });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const errMsg = this.state.error?.message || "Unknown error";
      const isChunkError =
        errMsg.includes("Loading chunk") ||
        errMsg.includes("ChunkLoadError") ||
        errMsg.includes("Loading CSS chunk");

      return (
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "'Inter', system-ui, sans-serif",
            background: "#f8fafc",
            padding: "24px",
          }}
          data-testid="chunk-error-boundary"
        >
          <div style={{ textAlign: "center", maxWidth: 420 }}>
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                background: "#fee2e2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 20px",
                fontSize: 28,
              }}
            >
              !
            </div>
            <h2
              style={{
                fontSize: 20,
                fontWeight: 600,
                color: "#1e293b",
                margin: "0 0 8px",
              }}
            >
              Page failed to load
            </h2>
            <p
              style={{
                fontSize: 14,
                color: "#64748b",
                margin: "0 0 24px",
                lineHeight: 1.5,
              }}
            >
              {isChunkError
                ? "This usually happens after an update. A quick refresh should fix it."
                : "Something went wrong loading this page. Please try refreshing."}
            </p>
            <button
              onClick={this.handleReload}
              data-testid="chunk-error-reload-btn"
              style={{
                padding: "10px 28px",
                fontSize: 14,
                fontWeight: 600,
                color: "#fff",
                background: "#2563eb",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
              }}
            >
              Refresh Page
            </button>
            <p
              style={{
                fontSize: 11,
                color: "#94a3b8",
                marginTop: 16,
                wordBreak: "break-word",
              }}
              data-testid="error-detail"
            >
              Error: {errMsg}
            </p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;
